import {
  BULKIMPORT_SET,
  BULKIMPORT_SET_SUCCESS,
  BULKIMPORT_SET_ERROR,
  CANDIDATE_SET,
  JOB_SET,
  ORG_DETAIL_GET_LIST,
  ORG_DETAIL_GET_LIST_SUCCESSFULL,
  ORG_DETAIL_GET_LIST_FAILED,
  GET_JOB_PROFILES,
  GET_JOB_PROFILES_SUCCESS,
  GET_JOB_PROFILES_FAILED,
  GET_CANDIDATE_BULK_IMPORT_STATUS,
  GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS,
  GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED,
  DELETE_ALL_RESUMES,
  DELETE_ALL_RESUMES_SUCCESS,
  DELETE_ALL_RESUMES_FAILED,
  GET_JOB_BULK_IMPORT_STATUS,
  GET_JOB_BULK_IMPORT_STATUS_SUCCESS,
  GET_JOB_BULK_IMPORT_STATUS_FAILED,
  DELETE_ALL_DESCRIPTIONS_SUCCESS,
  DELETE_ALL_DESCRIPTIONS_FAILED,
  DELETE_ALL_DESCRIPTIONS,
  DELETE_JD_REPOSITORY,DELETE_JD_REPOSITORY_STATUS_SUCCESS ,DELETE_JD_REPOSITORY_STATUS_FAIL, GET_JOB_PROFILES_SUGGESTION, GET_JOB_PROFILES_SUGGESTION_SUCCESS, GET_JOB_PROFILES_SUGGESTION_FAILED,
  GET_SAMPLE_CSV_JD_FILE,GET_SAMPLE_CSV_JD_FILE_SUCCESS,GET_SAMPLE_CSV_JD_FILE_FAILED,GET_SAMPLE_CSV_RESUME_FILE,GET_SAMPLE_CSV_RESUME_FILE_SUCCESS,GET_SAMPLE_CSV_RESUME_FILE_FAILED
} from "./actionTypes"

export const bulkimport = (user, history) => {
  return {
    type: BULKIMPORT_SET,
    payload: { user, history },
  }
}

export const bulkimportSuccess = message => {
  return {
    type: BULKIMPORT_SET_SUCCESS,
    payload: message,
  }
}

export const bulkimportSetError = message => {
  return {
    type: BULKIMPORT_SET_ERROR,
    payload: message,
  }
  
}

export const cadidateBulkimport = (user, history) => {

  return {
    type: CANDIDATE_SET,
    payload: { user, history },
  }
}
export const jobBulkimport = (user, history) => {

  return {
    type: JOB_SET,
    payload: { user, history },
  }
}

export const getOrgList = (orgDetail) => {
  return {
    type: ORG_DETAIL_GET_LIST,
    payload: {orgDetail},
  }
}
export const getOrgListSuccess = (orgDetail) => {
  return {
    type: ORG_DETAIL_GET_LIST_SUCCESSFULL,
    payload: {orgDetail},
  }
}
export const getOrgListError = (orgDetail) => {
  return {
    type: ORG_DETAIL_GET_LIST_FAILED,
    payload: {orgDetail},
  }
}

export const getJobProfiles=(data)=>{
  return{
    type:GET_JOB_PROFILES,
    payload:{data}

  }

}

export const getJobProfilesSuccess=(data)=>{
  return{
    type:GET_JOB_PROFILES_SUCCESS,
    payload:{data}
  }
}

export const getJobProfilesFailed=(error)=>{
  return{
    type:GET_JOB_PROFILES_FAILED,
    payload:{error}
  }
}

export const getCandidateBulkImportStatus=(id)=>{
  return{
    type:GET_CANDIDATE_BULK_IMPORT_STATUS,
    payload:{id}
  }
}

export const getCandidateBulkImportStatusSuccess=(data)=>{
  return{
    type:GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS,
    payload:data
  }
}

export const getCandidateBulkImportStatusFailed=(error)=>{
  return{
    type:GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED,
    payload:error
  }
}

export const getJobBulkImportStatus=(id)=>{
  return{
    type:GET_JOB_BULK_IMPORT_STATUS,
    payload:{id}
  }
}

export const getJobBulkImportStatusSuccess=(data)=>{
  return{
    type:GET_JOB_BULK_IMPORT_STATUS_SUCCESS,
    payload:data
  }
}

export const getJobBulkImportStatusFailed=(error)=>{
  return{
    type:GET_JOB_BULK_IMPORT_STATUS_FAILED,
    payload:error
  }
}

export const deleteAllResumes=(id)=>{
  return{
    type:DELETE_ALL_RESUMES,
    payload:{id}
  }
}

export const deleteAllResumesSuccess=(message)=>{
  return{
    type:DELETE_ALL_RESUMES_SUCCESS,
    payload:message
  }

}

export const deleteAllResumesFailed=(error)=>{
  return{
    type:DELETE_ALL_RESUMES_FAILED,
    payload:error
  }

}

export const deleteAllDescriptions=(id)=>{
  return{
    type:DELETE_ALL_DESCRIPTIONS,
    payload:{id}
  }
}

export const deleteAllDescriptionsSuccess=(message)=>{
  return{
    type:DELETE_ALL_DESCRIPTIONS_SUCCESS,
    payload:message
  }

}

export const deleteAllDescriptionsFailed=(error)=>{
  return{
    type:DELETE_ALL_DESCRIPTIONS_FAILED,
    payload:error
  }

}


//jd repository delete
export const deleteJdRepository=(id)=>{
  return{
    type:DELETE_JD_REPOSITORY,
    payload:{id}
  }
}

export const  deleteJdRepositorySuccess=(message)=>{
  return{
    type:DELETE_JD_REPOSITORY_STATUS_SUCCESS,
    payload:message
  }

}

export const deleteJdRepositoryFailed=(error)=>{
  return{
    type:DELETE_JD_REPOSITORY_STATUS_FAIL,
    payload:error
  }


}

export const jobBulkimportJobProfileSuggestions = (keyword) => {
  return {
    type: GET_JOB_PROFILES_SUGGESTION,
    payload: { keyword },
  }
}

export const jobBulkimportJobProfileSuggestionsSuccess = keyword => {
  return {
    type: GET_JOB_PROFILES_SUGGESTION_SUCCESS,
    payload: keyword,
  }
}

export const jobBulkimportJobProfileSuggestionsError = keyword => {
  return {
    type: GET_JOB_PROFILES_SUGGESTION_FAILED,
    payload: keyword,
  }
  
}

export const getSampleJdFile = () => {
  return {
    type: GET_SAMPLE_CSV_JD_FILE,
    
  }
  
}

export const getSampleJdFileSuccess = (data) => {
  return {
    type: GET_SAMPLE_CSV_JD_FILE_SUCCESS,
    payload:data
    
  }
  
}

export const getSampleJdFileFailure = (error) => {
  return {
    type: GET_SAMPLE_CSV_JD_FILE_FAILED,
    payload:error
    
  }
  
}

export const getSampleResumeFile = () => {
  return {
    type: GET_SAMPLE_CSV_RESUME_FILE,
    
  }
  
}

export const getSampleResumeFileSuccess = (data) => {
  return {
    type: GET_SAMPLE_CSV_RESUME_FILE_SUCCESS,
    payload:data
    
  }
  
}

export const getSampleResumeFileFailure = (error) => {
  return {
    type: GET_SAMPLE_CSV_RESUME_FILE_FAILED,
    payload:error
    
  }
  
}